import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}`;

export const loggedUserUrls = {
  'app.loggedUser.tasks' : `${BASE_URL}/my-tasks`,
}
